import React from "react";
import {
  Leaf, Egg, Fish, Flame, Apple, Milk, Wheat, Bean, Sprout,
  TreePine, Sun, Droplets, Package, Beef, Grape, Citrus,
  Carrot, Banana, Flower2, Drumstick,
} from "lucide-react";

export interface CategoryItem {
  id: number;
  name: string;
  parentId?: number | null;
  color?: string;
  icon: React.ComponentType<{ size?: number; color?: string }>;
     image?: any;
}

/* ======================================================
   🌾 FARM DOMAIN (1530xxxxx)
   Direct-from-farm: what mama mboga & farmers sell —
   cereals, legumes, fresh & dry veg, fruits, roots,
   herbs, eggs, meat, dairy, oilseeds, honey, mushrooms
   ====================================================== */

export const farmCategories: CategoryItem[] = [
  { id: 153000001, name: "Cereals & Grains",          color: "#D4A017", icon: Wheat },
  { id: 153000002, name: "Legumes & Pulses",           color: "#7B8C3E", icon: Bean },
  { id: 153000003, name: "Fresh Vegetables",           color: "#2E8B57", icon: Leaf },
  { id: 153000004, name: "Dry & Sun-Dried Produce",   color: "#A0522D", icon: Sun },
  { id: 153000005, name: "Fresh Fruits",               color: "#FF6347", icon: Apple },
  { id: 153000006, name: "Roots & Tubers",             color: "#CD853F", icon: Carrot },
  { id: 153000007, name: "Herbs & Leafy Greens",      color: "#3CB371", icon: Sprout },
  { id: 153000008, name: "Eggs & Poultry",             color: "#F4A460", icon: Egg },
  { id: 153000009, name: "Farm Meat",                  color: "#C0392B", icon: Beef },
  { id: 153000010, name: "Fresh Dairy",                color: "#FFFACD", icon: Milk },
  { id: 153000011, name: "Oilseeds & Nuts",            color: "#8B6914", icon: TreePine },
  { id: 153000012, name: "Honey & Natural Sugars",    color: "#FFA500", icon: Droplets },
  { id: 153000013, name: "Mushrooms & Fungi",          color: "#9B7653", icon: Flower2 },
  { id: 153000014, name: "Fodder & Animal Feed",       color: "#6B8E23", icon: Package },
];

export const farmSubcategories: CategoryItem[] = [
  /* Cereals */
  { id: 153000101, parentId: 153000001, name: "Maize / Corn",              icon: Wheat },
  { id: 153000102, parentId: 153000001, name: "Rice (Paddy & Milled)",     icon: Wheat },
  { id: 153000103, parentId: 153000001, name: "Wheat & Barley",            icon: Wheat },
  { id: 153000104, parentId: 153000001, name: "Sorghum & Millet",          icon: Wheat },
  { id: 153000105, parentId: 153000001, name: "Oats & Rye",                icon: Wheat },
  { id: 153000106, parentId: 153000001, name: "Flour & Posho (Milled)",    icon: Package },

  /* Legumes */
  { id: 153000201, parentId: 153000002, name: "Dry Beans (Red/White)",     icon: Bean },
  { id: 153000202, parentId: 153000002, name: "Lentils & Dal",             icon: Bean },
  { id: 153000203, parentId: 153000002, name: "Peas (Dry & Fresh)",        icon: Bean },
  { id: 153000204, parentId: 153000002, name: "Chickpeas",                 icon: Bean },
  { id: 153000205, parentId: 153000002, name: "Soybeans",                  icon: Bean },
  { id: 153000206, parentId: 153000002, name: "Cowpeas / Black-eyed Peas", icon: Bean },
  { id: 153000207, parentId: 153000002, name: "Green Grams (Ndengu)",      icon: Bean },
  { id: 153000208, parentId: 153000002, name: "Pigeon Peas (Njugu Mawe)",  icon: Bean },

  /* Fresh Veg */
  { id: 153000301, parentId: 153000003, name: "Tomatoes",                  icon: Leaf },
  { id: 153000302, parentId: 153000003, name: "Onions & Garlic",           icon: Leaf },
  { id: 153000303, parentId: 153000003, name: "Cabbages & Kale (Sukuma)", icon: Leaf },
  { id: 153000304, parentId: 153000003, name: "Capsicum & Hot Peppers",    icon: Flame },
  { id: 153000305, parentId: 153000003, name: "Courgettes & Squash",       icon: Leaf },
  { id: 153000306, parentId: 153000003, name: "Broccoli & Cauliflower",    icon: Sprout },
  { id: 153000307, parentId: 153000003, name: "Spinach & Managu",          icon: Leaf },
  { id: 153000308, parentId: 153000003, name: "Cucumber & Eggplant",       icon: Leaf },
  { id: 153000309, parentId: 153000003, name: "Carrots",                   icon: Carrot },
  { id: 153000310, parentId: 153000003, name: "Leeks & Spring Onions",     icon: Leaf },
  { id: 153000311, parentId: 153000003, name: "French Beans & Snow Peas",  icon: Sprout },
  { id: 153000312, parentId: 153000003, name: "Beetroot & Radish",         icon: Carrot },

  /* Dry Produce */
  { id: 153000401, parentId: 153000004, name: "Dried Tomatoes",            icon: Sun },
  { id: 153000402, parentId: 153000004, name: "Dried Chilies",             icon: Flame },
  { id: 153000403, parentId: 153000004, name: "Dried Mushrooms",           icon: Sun },
  { id: 153000404, parentId: 153000004, name: "Dried Cassava (Makopa)",    icon: Package },
  { id: 153000405, parentId: 153000004, name: "Dried Fish (Omena/Dagaa)",  icon: Fish },
  { id: 153000406, parentId: 153000004, name: "Dried Banana (Ngumu)",      icon: Banana },

  /* Fresh Fruits */
  { id: 153000501, parentId: 153000005, name: "Mangoes",                   icon: Apple },
  { id: 153000502, parentId: 153000005, name: "Avocados",                  icon: Leaf },
  { id: 153000503, parentId: 153000005, name: "Bananas & Plantains",       icon: Banana },
  { id: 153000504, parentId: 153000005, name: "Passion Fruit & Guava",     icon: Apple },
  { id: 153000505, parentId: 153000005, name: "Citrus (Oranges, Lemons)",  icon: Citrus },
  { id: 153000506, parentId: 153000005, name: "Pineapple & Pawpaw",        icon: Apple },
  { id: 153000507, parentId: 153000005, name: "Watermelon & Melon",        icon: Apple },
  { id: 153000508, parentId: 153000005, name: "Apples & Pears",            icon: Apple },
  { id: 153000509, parentId: 153000005, name: "Grapes & Berries",          icon: Grape },
  { id: 153000510, parentId: 153000005, name: "Coconuts",                  icon: TreePine },
  { id: 153000511, parentId: 153000005, name: "Tamarind & Baobab",         icon: TreePine },

  /* Roots & Tubers */
  { id: 153000601, parentId: 153000006, name: "Sweet Potatoes",            icon: Carrot },
  { id: 153000602, parentId: 153000006, name: "Irish Potatoes",             icon: Carrot },
  { id: 153000603, parentId: 153000006, name: "Cassava (Fresh)",            icon: Carrot },
  { id: 153000604, parentId: 153000006, name: "Arrow Roots (Nduma)",        icon: Carrot },
  { id: 153000605, parentId: 153000006, name: "Yams",                       icon: Carrot },
  { id: 153000606, parentId: 153000006, name: "Ginger & Turmeric",          icon: Flame },
  { id: 153000607, parentId: 153000006, name: "Cocoyam (Arrowhead)",        icon: Carrot },

  /* Herbs */
  { id: 153000701, parentId: 153000007, name: "Coriander & Parsley",       icon: Sprout },
  { id: 153000702, parentId: 153000007, name: "Mint & Basil",              icon: Sprout },
  { id: 153000703, parentId: 153000007, name: "Dill & Thyme",              icon: Sprout },
  { id: 153000704, parentId: 153000007, name: "African Nightshade (Managu)",icon: Leaf },
  { id: 153000705, parentId: 153000007, name: "Amaranth (Terere)",          icon: Leaf },
  { id: 153000706, parentId: 153000007, name: "Cowpea Leaves (Kunde)",     icon: Leaf },
  { id: 153000707, parentId: 153000007, name: "Lemongrass & Rosemary",     icon: Sprout },

  /* Eggs & Poultry */
  { id: 153000801, parentId: 153000008, name: "Chicken Eggs (Tray of 30)", icon: Egg },
  { id: 153000802, parentId: 153000008, name: "Duck & Quail Eggs",         icon: Egg },
  { id: 153000803, parentId: 153000008, name: "Live Chicken (Kienyeji)",   icon: Drumstick },
  { id: 153000804, parentId: 153000008, name: "Dressed / Slaughtered Chicken", icon: Drumstick },
  { id: 153000805, parentId: 153000008, name: "Turkey",                    icon: Drumstick },
  { id: 153000806, parentId: 153000008, name: "Guinea Fowl",               icon: Drumstick },

  /* Farm Meat */
  { id: 153000901, parentId: 153000009, name: "Beef (Farm-fresh cuts)",    icon: Beef },
  { id: 153000902, parentId: 153000009, name: "Goat & Mutton",             icon: Beef },
  { id: 153000903, parentId: 153000009, name: "Pork",                      icon: Beef },
  { id: 153000904, parentId: 153000009, name: "Rabbit",                    icon: Beef },
  { id: 153000905, parentId: 153000009, name: "Camel Meat",                icon: Beef },
  { id: 153000906, parentId: 153000009, name: "Offals & Tripe",            icon: Beef },
  { id: 153000907, parentId: 153000009, name: "Sausages (Farm-made)",      icon: Beef },

  /* Fresh Dairy */
  { id: 153001001, parentId: 153000010, name: "Fresh Cow Milk",            icon: Milk },
  { id: 153001002, parentId: 153000010, name: "Goat Milk",                 icon: Milk },
  { id: 153001003, parentId: 153000010, name: "Fermented Milk (Mala)",     icon: Milk },
  { id: 153001004, parentId: 153000010, name: "Butter & Ghee (Farm)",      icon: Milk },
  { id: 153001005, parentId: 153000010, name: "Local Cheese",              icon: Milk },

  /* Oilseeds */
  { id: 153001101, parentId: 153000011, name: "Sunflower Seeds",           icon: Sun },
  { id: 153001102, parentId: 153000011, name: "Groundnuts / Peanuts",      icon: Bean },
  { id: 153001103, parentId: 153000011, name: "Sesame (Simsim)",           icon: Sun },
  { id: 153001104, parentId: 153000011, name: "Macadamia Nuts",            icon: TreePine },
  { id: 153001105, parentId: 153000011, name: "Cashew Nuts (Raw)",         icon: TreePine },
  { id: 153001106, parentId: 153000011, name: "Chia & Flax Seeds",         icon: Sprout },

  /* Honey */
  { id: 153001201, parentId: 153000012, name: "Raw Wildflower Honey",      icon: Droplets },
  { id: 153001202, parentId: 153000012, name: "Beeswax",                   icon: Droplets },
  { id: 153001203, parentId: 153000012, name: "Sugarcane (Fresh stalks)",  icon: Droplets },
  { id: 153001204, parentId: 153000012, name: "Propolis",                  icon: Droplets },

  /* Mushrooms */
  { id: 153001301, parentId: 153000013, name: "Oyster Mushrooms",          icon: Flower2 },
  { id: 153001302, parentId: 153000013, name: "Button Mushrooms",          icon: Flower2 },
  { id: 153001303, parentId: 153000013, name: "Wild / Forest Mushrooms",   icon: Flower2 },

  /* Fodder */
  { id: 153001401, parentId: 153000014, name: "Hay Bales",                 icon: Package },
  { id: 153001402, parentId: 153000014, name: "Napier Grass",              icon: Leaf },
  { id: 153001403, parentId: 153000014, name: "Dairy Meal / Concentrates", icon: Package },
  { id: 153001404, parentId: 153000014, name: "Silage",                   icon: Package },
];

export const farmProducts: CategoryItem[] = [
  { id: 153010101, parentId: 153000101, name: "White Maize (1 kg)",        icon: Wheat },
  { id: 153010102, parentId: 153000101, name: "Maize Flour Posho (2 kg)",  icon: Package },
  { id: 153010201, parentId: 153000201, name: "Red Kidney Beans (1 kg)",   icon: Bean },
  { id: 153010202, parentId: 153000207, name: "Green Grams Ndengu (500 g)",icon: Bean },
  { id: 153010301, parentId: 153000301, name: "Roma Tomatoes (1 kg)",      icon: Leaf },
  { id: 153010302, parentId: 153000302, name: "Red Onions (1 kg)",         icon: Leaf },
  { id: 153010303, parentId: 153000303, name: "Sukuma Wiki Kale (bunch)",  icon: Leaf },
  { id: 153010501, parentId: 153000501, name: "Alphonso Mangoes (1 kg)",   icon: Apple },
  { id: 153010502, parentId: 153000502, name: "Hass Avocados (1 kg)",      icon: Leaf },
  { id: 153010503, parentId: 153000503, name: "Bananas — bunch",           icon: Banana },
  { id: 153010601, parentId: 153000601, name: "Sweet Potatoes (1 kg)",     icon: Carrot },
  { id: 153010602, parentId: 153000602, name: "Irish Potatoes (1 kg)",     icon: Carrot },
  { id: 153010603, parentId: 153000603, name: "Fresh Cassava (1 kg)",      icon: Carrot },
  { id: 153010801, parentId: 153000801, name: "Eggs — Tray of 30",         icon: Egg },
  { id: 153010901, parentId: 153000901, name: "Beef Rib (per kg)",         icon: Beef },
  { id: 153010902, parentId: 153000902, name: "Goat Leg (per kg)",         icon: Beef },
  { id: 153011001, parentId: 153001001, name: "Fresh Cow Milk (1 litre)",  icon: Milk },
  { id: 153011201, parentId: 153001201, name: "Raw Honey (500 g jar)",     icon: Droplets },
];

export const farmUnits = [
  { id: 15309001, name: "Per kg" },
  { id: 15309002, name: "Per 50 kg bag" },
  { id: 15309003, name: "Per 90 kg bag" },
  { id: 15309004, name: "Per crate" },
  { id: 15309005, name: "Per tray (30 eggs)" },
  { id: 15309006, name: "Per dozen" },
  { id: 15309007, name: "Per litre" },
  { id: 15309008, name: "Per head (livestock)" },
  { id: 15309009, name: "Per bunch" },
  { id: 15309010, name: "Per bale" },
  { id: 15309011, name: "Per piece" },
  { id: 15309012, name: "Per 250 g" },
];

export const farmVariants = [
  { id: 15309101, name: "Fresh (same day harvest)" },
  { id: 15309102, name: "Organic / Chemical-free" },
  { id: 15309103, name: "Free-range" },
  { id: 15309104, name: "Sun-dried" },
  { id: 15309105, name: "Smoked" },
  { id: 15309106, name: "Certified Grade A" },
  { id: 15309107, name: "Local breed" },
  { id: 15309108, name: "Imported / Exotic breed" },
];

/**
 * Renders the icon for a farm category/subcategory/product item.
 *
 * IMPORTANT: this takes the full CategoryItem (so it can read both
 * `.icon` and `.color`), not a bare icon component. This matches how
 * it's invoked from CategoryDetails.tsx's resolveItemIcon:
 *   renderFarmIconFn(item, size)
 *
 * `overrideColor` lets callers (e.g. a selected/active tree row) force
 * a color other than the item's own `.color`.
 */
export const renderFarmIcon = (
  item: CategoryItem | null | undefined,
  size = 22,
  overrideColor?: string
) => {
  if (!item || typeof item.icon !== "function") return null;
  const Icon = item.icon;
  const color = overrideColor ?? item.color ?? "#555";
  return <Icon size={size} color={color} />;
};